export default "<p>types-for-service-assignment works!</p>\n";